import { render, staticRenderFns } from "./MenuGroupScheduleListAddEdit.vue?vue&type=template&id=04668bf2"
import script from "./MenuGroupScheduleListAddEdit.vue?vue&type=script&lang=js"
export * from "./MenuGroupScheduleListAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports